import React from 'react';
import * as Toggle from '@radix-ui/react-toggle';

export default function InputToggle({ isActive, setIsActive, label }) {
  return (
    <Toggle.Root
      pressed={isActive}
      onPressedChange={(value) => {
        setIsActive(value);
      }}
      data-component-name='InputToggle'
      aria-label='Toggle socioeconomic factor layer'
      className='flex items-center gap-2.5'
    >
      <div
        className={`${
          isActive === true ? 'bg-orange-500' : 'bg-blue-50'
        } w-[35px] h-5 rounded-full flex items-center px-1 transition-colors duration-200`}
      >
        <div
          className={`${
            isActive === true ? 'translate-x-[13px]' : 'translate-x-0'
          } rounded-full bg-white-400 h-3.5 w-3.5 transition-transform duration-200`}
        ></div>
      </div>

      <span className='text-base text-blue-500'>{label}</span>
    </Toggle.Root>
  );
}
